export default "__VITE_ASSET__CFW59wSw__"